import { Lock } from "lucide-react";
import type { ReactNode } from "react";
import { BackButton } from "../shell/BackButton";

/* `reports` is deliberately absent: the Reports screen (08) is wired to
   GET /v1/reports/preview and the `reports` route renders it, so no entry here may call
   that family "under construction". A stub entry would have been dead config that
   contradicted a working screen. (The rail still disables Reports at Easy M, because the
   server sends `stub: true` for that tier in rail_families — that is a server-side flag,
   not this screen's to change.) */
const FAMILY_INFO: Record<string, { title: string; tier: string; stub?: boolean }> = {
  actions: { title: "Actions", tier: "Easy T" },
  ledgers: { title: "Ledgers", tier: "Easy T" },
  work: { title: "Work", tier: "Easy T" },
  docs: { title: "Documents", tier: "Easy T" },
  ask: { title: "Ask", tier: "Easy T" },
  performance: { title: "Performance", tier: "Easy M", stub: true },
  equipment: { title: "Equipment", tier: "Easy M", stub: true },
  weather: { title: "Weather and forecast", tier: "Easy M", stub: true },
  settings: { title: "Settings", tier: "Easy M", stub: true },
  alerts: { title: "Alerts", tier: "Easy M", stub: true },
};

export function LockedFamilyScreen(props: { family: string; subtitle?: string }): ReactNode {
  const info = FAMILY_INFO[props.family] ?? { title: props.family, tier: "a higher tier" };

  return (
    <div style={container}>
      <div style={iconWrap}>
        <Lock size={32} aria-hidden />
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <BackButton />
        <h1 style={title}>{info.title}</h1>
      </div>
      {props.subtitle ? <p style={subtitle}>{props.subtitle}</p> : null}
      <p style={message}>
        {info.stub
          ? "This page is under construction."
          : `Available with ${info.tier}. Contact your administrator to upgrade.`}
      </p>
    </div>
  );
}

const container: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "4rem 1rem",
  textAlign: "center",
};
const iconWrap: React.CSSProperties = {
  color: "var(--sk-color-ink-3)",
};
const title: React.CSSProperties = {
  margin: 0,
  font: "600 20px/1.25 var(--sk-font-text)",
  color: "var(--sk-color-ink-1)",
};
const subtitle: React.CSSProperties = {
  margin: 0,
  font: "400 13px/1.4 var(--sk-font-text)",
  color: "var(--sk-color-ink-2)",
};
const message: React.CSSProperties = {
  margin: 0,
  font: "400 14px/1.5 var(--sk-font-text)",
  color: "var(--sk-color-ink-3)",
  maxWidth: 360,
};
